import client from './client';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const fetchAccountInfo = async () => {
    const response = await client.get('/api/auth/account', { headers: getAuthHeaders() });
    return response.data;
};

export const changePassword = async (currentPassword, newPassword, confirmNewPassword) => {
    const response = await client.put('/api/auth/password', {
        currentPassword,
        newPassword,
        confirmNewPassword,
    }, { headers: getAuthHeaders() });
    return response.data;
};

export const deleteAccount = async (password) => {
    const response = await client.delete('/api/auth/account', {
        headers: getAuthHeaders(),
        data: { password },
    });
    return response.data;
};

export const updateName = async (name) => {
    const response = await client.put('/api/auth/name', { name }, { headers: getAuthHeaders() });
    return response.data;
};

export const updateEmailPreferences = async (weeklyDigest) => {
    const response = await client.put('/api/email/preferences', {
        weeklyDigest,
    }, { headers: getAuthHeaders() });
    return response.data;
};

export const exportData = async () => {
    const response = await client.get('/api/auth/export', {
        headers: getAuthHeaders(),
        responseType: 'blob',
    });
    return response.data;
};
